export const getCurrencyCodeByIndex = (index) => {
	const allCurrencies = {
		0: 'EUR',
		1: 'USD',
		2: 'CHF',
		3: 'GBP',
		4: 'NZD',
		5: 'DKK',
		6: 'SEK',
		7: 'ILS',
		8: 'CAD'
	};

	index = parseInt(index, 10);

	if (index <= 0 || index > 8) index = 0;

	return allCurrencies[index];
};

export const getCurrencySymbolByCode = (str) => {
	const allCurrencies = {
		EUR: '€',
		USD: '$',
		CHF: 'fr',
		GBP: '£',
		NZD: '$NZ',
		DKK: 'kr.',
		SEK: 'kr',
		ILS: '₪',
		CAD: '$CAD'
	};

	return allCurrencies[str.toUpperCase()] || '';
};

export const getCurrencyFormatByIndex = (index) => {
	const allCurrencies = {
		0: 'en-US', // EN-US
		1: 'en-UK', // EN-UK
		2: 'fr-FR', // FR-FR
		3: 'fr-BE', // FR-BE
		4: 'fr-CA', // FR-CA
		5: 'fr-CH', // FR-CH
		6: 'de-DE' // SUB-E
	};

	index = parseInt(index, 10);

	if (index <= 0 || index > 6) index = 0;

	return allCurrencies[index];
};
